module.exports = __webpack_public_path__ + "static/React-Iphone-8d4bcba77543717ef7536fa47fe9dd5d.mp4";